import { InternalAxiosRequestConfig } from "axios";
import { authRequestInterceptor } from "./authRequestInterceptor";
import { baseUrlGatewayRequestInterceptor } from "./baseUrlGatewayRequestInterceptor";
import { guestAbortRequestInterceptor } from "./guestAbortRequestInterceptor";
import { logInterReq } from "./logInterReq";
import { spTraceInterReq } from "./spTraceInterReq";
export const comboGWInterceptorReq = async (request: InternalAxiosRequestConfig) => {
  request = guestAbortRequestInterceptor(request);
  request = baseUrlGatewayRequestInterceptor(request);
  request = spTraceInterReq(request);
  request = logInterReq(request);
  request = await authRequestInterceptor(request);
  return request;
};
